import constants from "./constants";
import { getFeaturesForLocation, getDynamicFeaturesForLocation } from "./fetchFeatures";

// Legacy function - kept for backward compatibility
export const showBookNow = (city: string) => {
  return getFeaturesForLocation(city).showBookNow;
};

// New function that can accept cities data for dynamic lookup
export const showBookNowDynamic = (city: string, cities?: any[]) => {
  if (cities && cities.length > 0) {
    return getDynamicFeaturesForLocation(city, cities).showBookNow;
  }
  // Fallback to hardcoded config
  return getFeaturesForLocation(city).showBookNow;
};